'use client'

import { Button } from '@graftcode/design-system'

import { UNAUTHENTICATED_BANNER_TEST_IDS } from '@common/common-test-ids.const'

import styles from './UnauthenticatedBanner.module.scss'

export interface UnauthenticatedBannerProps {
  signUpMessage?: string
  signUpButtonLabel?: string
  onSignUpClick?: () => void
}

export function UnauthenticatedBanner({
  signUpMessage = 'Sign up now to explore the complete Graftcode platform.',
  signUpButtonLabel = 'Sign up',
  onSignUpClick,
}: UnauthenticatedBannerProps) {
  return (
    <div className={styles.wrapper} data-testid={UNAUTHENTICATED_BANNER_TEST_IDS.root}>
      <div className={styles.content}>
        <p className={styles.message}>{signUpMessage}</p>
        <Button size="s" variant="primary" onClick={onSignUpClick}>
          {signUpButtonLabel}
        </Button>
      </div>
    </div>
  )
}
